















import { defineComponent, toRefs, PropType } from '@vue/composition-api';
import { AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import SavedAudienceCreate from './index';
const name = 'ttam-saved-audience-create-compose';
export default defineComponent({
  name,
  components: {
    TtamSavedAudienceCreateSubcpn: SavedAudienceCreate.TtamSavedAudienceCreateSubcpn,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    detailData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, detailData } = toRefs(props);
    const { handleClickSavedButton, savedAudienceDetails } = SavedAudienceCreate.useSavedAudienceDetailData({
      adgroupData,
      campaignData,
      targetSummaryData: detailData,
    });

    const { isSavedAudienceVisible } = SavedAudienceCreate.usePropsSavedAudienceVisible({
      adgroupData,
      campaignData,
    });

    const { handleSavedAudienceCreate, manageSavedAudience, handleSavedAudienceSuccess } =
      SavedAudienceCreate.useSavedAudienceCreate({
        adgroupData,
        campaignData,
      });

    async function handleSavedAudienceCreateSuccess(savedAudienceId) {
      await handleSavedAudienceSuccess();
      emit('create-success', savedAudienceId);
    }
    const learnMoreHref = 'https://ads.tiktok.com/help/article/about-saved-audience';
    return {
      name,
      savedAudienceDetails,
      isSavedAudienceVisible,
      handleClickSavedButton,
      handleSavedAudienceCreate,
      manageSavedAudience,
      handleSavedAudienceCreateSuccess,
      learnMoreHref,
    };
  },
});
